import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, PropType, watch, onMounted } from "vue";
import GridFiltersBase from "../../ui/grid/grid-filters-base.vue";
import lookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { CodeType } from "acquaint-api/constants/CodeType";
import { FindPropertiesFilters } from "@/types/properties/FindPropertiesFilters";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-property-filters-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /** 
     * Filters applied to the property.
     @type {FindPropertiesFilters} - An object defining the filter criteria.  
     */
  filters: {
    type: Object as PropType<FindPropertiesFilters>,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when filters are applied from the grid filters base.
   * @event filtersApplied
   * @property {FindPropertiesFilters} filters - The applied filters from the modal.
   */
  "filtersApplied",
],
  setup(__props, { emit }) {

const props = __props;





onMounted(async () => {
  clonePropFilters();
});

watch(
  () => props.modelValue,
  () => {
    if (!props.modelValue) {
      return;
    }
    // Need to clone the passed filters to avoid them updating before the user clicks the apply button
    clonePropFilters();
  },
);

/** Clones the prop filters so changes aren't applied until the user clicks the apply button */
const clonePropFilters = () => {
  /* To clone filters we can't use the spread command, as this only does a shallow clone.
   * To do a deep clone, we need to convert the filters to json and back to an array */
  if (props.filters) {
    modalFilter.value = JSON.parse(JSON.stringify(props.filters));
  }
};

/** Handles the filters applied event from the grid filters base */
const onFiltersApplied = () => emit("filtersApplied", modalFilter.value);

/** Handles the clear filters event from the grid filters base */
const onClearFilters = () => {
  modalFilter.value.category = { id: -1, description: "" };
  modalFilter.value.status = { id: -1, description: "" };
  modalFilter.value.branch = { id: -1, description: "" };
};

const modalFilter = ref<FindPropertiesFilters>({
  category: { id: -1, description: "" },
  status: { id: -1, description: "" },
  branch: { id: -1, description: "" },
});

const showFilters = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const categoryValueChanged = (selectedDescription: string) => {
  modalFilter.value.category.description = selectedDescription;
};

const statusValueChanged = (selectedDescription: string) => {
  modalFilter.value.status.description = selectedDescription;
};

const branchValueChanged = (selectedDescription: string) => {
  modalFilter.value.branch.description = selectedDescription;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GridFiltersBase, {
    "data-source": "modalFilter",
    modelValue: showFilters.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showFilters).value = $event)),
    title: "Find Property Filters",
    onClearFilters: onClearFilters,
    onFiltersApplied: onFiltersApplied
  }, {
    filters: _withCtx(() => [
      _createVNode(SystemCodeSingleSelect, {
        label: "Category",
        modelValue: modalFilter.value.category.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modalFilter.value.category.id) = $event)),
        "code-type": _unref(CodeType).PropertyCategory,
        showClearButton: true,
        onValueChanged: categoryValueChanged
      }, null, 8, ["modelValue", "code-type"]),
      _createVNode(SystemCodeSingleSelect, {
        label: "Status",
        modelValue: modalFilter.value.status.id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalFilter.value.status.id) = $event)),
        "code-type": _unref(CodeType).PropertyStatus,
        showClearButton: true,
        onValueChanged: statusValueChanged
      }, null, 8, ["modelValue", "code-type"]),
      _createVNode(lookupSingleSelect, {
        label: "Branch",
        modelValue: modalFilter.value.branch.id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modalFilter.value.branch.id) = $event)),
        "lookup-source": _unref(LookupTableSource).Sites,
        showClearButton: true,
        onValueChanged: branchValueChanged
      }, null, 8, ["modelValue", "lookup-source"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})